export const supportedLocales = ["de-DE", "en-EN"];
export const supportedLocalesUs = ["en-EN"];
